import { IImportLeadPayload } from "../types/api";
import { IProduct } from "../types/product";


type KlaviyoPushPrams =
  | [
      'identify' | 'track' | 'trackViewedItem',
      (
        | 'Viewed Product'
        | 'Started Checkout'
        | 'Added to Cart'
        | 'API_QUIZ_FINISHED'
        | Record<string, unknown>
      ),
      Record<string, unknown>,
    ]
  | ['identify' | 'track' | 'trackViewedItem', Record<string, unknown>];

export class Klaviyo {
  static push = (params: KlaviyoPushPrams) => {
    if (!window._learnq) {
      window._learnq = [];
    }
    window._learnq?.push(params);
  };

  static trackActiveOnSite = (lead: Partial<IImportLeadPayload>) => {
    Klaviyo.push([
      'identify',
      {
        $first_name: lead?.firstName || '',
        $last_name: lead?.lastName || '',
        $email: lead?.emailAddress,
        $phone_number:
          String(lead?.phoneNumber)
            ?.replace('+', '')
            ?.trim() || '',
      },
    ]);
  };

  static trackViewedProduct = (product: IProduct) => {
    Klaviyo.push([
      'track',
      'Viewed Product',
      {
        id: Number(product?.id),
        name: product?.name,
        imageURL: product.image,
        url: window.location.href,
        price: String(product.finalPrice),
        checkoutURL: window.location.href,
      },
    ]);

    Klaviyo.push([
      'trackViewedItem',
      {
        ItemId: product.id,
        Title: product.name,
        Price: String(product.finalPrice),
      },
    ]);
  };

  static trackStartedCheckout = (product: IProduct) => {
    Klaviyo.push([
      'track',
      'Started Checkout',
      {
        $event_id: new Date().toISOString(),
        $value: product.finalPrice,
        Items: [
          {
            Quantity: 1,
            ProductID: product.id,
            imageURL: product.image,
            ProductName: product.name,
            RowTotal: product.finalPrice,
            ItemPrice: product.finalPrice,
            ProductURL: window.location.href,
            checkoutURL: window.location.href,
          },
        ],
      },
    ]);
  };

  static trackAddToCart = (lead: IImportLeadPayload, product: IProduct) => {
    Klaviyo.trackActiveOnSite(lead);
    // Klaviyo.trackStartedCheckout(product);

    Klaviyo.push([
      'track',
      'Added to Cart',
      {
        $value: product.finalPrice,
        AddedItemProductName: product.name,
        AddedItem_Quantity: 1,
        Items: [
          {
            ProductID: product.id,
            ProductName: product.name,
            Quantity: 1,
            ItemPrice: product.finalPrice,
            imageURL: product.image,
            ProductURL: window.location.href,
            checkoutURL: window.location.href,
          },
        ],
      },
    ]);
  };

  static trackQuizFinished = (asnwers: Record<string, string | string[]>) => {
    const urlParams = new URLSearchParams(window.location.search);
    Klaviyo.push([
      'track',
      'API_QUIZ_FINISHED',
      {
        UTMCampaign: urlParams.get('utm_campaign') || '',
        UTMTerm: urlParams.get('utm_term') || '',
        UTMSource: urlParams.get('utm_source') || '',
        UTMMedium: urlParams.get('utm_medium') || '',
        ...asnwers,
      },
    ]);
  };
}
